export default "__VITE_ASSET__c7ca6a40__"